import React, { useState } from "react";

const PRESETS = [
  { label: "Under ₹1,000", min: 0, max: 1000 },
  { label: "₹1,000 – ₹2,500", min: 1000, max: 2500 },
  { label: "₹2,500 – ₹5,000", min: 2500, max: 5000 },
  { label: "₹5,000 – ₹10,000", min: 5000, max: 10000 },
  { label: "Above ₹10,000", min: 10000, max: "" },
];

// Applied from the nav bar, so it isn't scoped to one category — it routes to
// the "all products" listing (/collections/all) with the range as query params.
// Positioning (flyout vs. inline) is owned by the caller, since desktop and
// mobile nav render this in very different contexts.
const PriceRangeDropdown = ({ onApply, className = "" }) => {
  const [customMin, setCustomMin] = useState("");
  const [customMax, setCustomMax] = useState("");

  return (
    <div className={`text-sm ${className}`}>
      <ul>
        {PRESETS.map((preset) => (
          <li key={preset.label}>
            <button
              type="button"
              onClick={() => onApply(preset.min, preset.max)}
              className="w-full text-left px-4 py-2 hover:bg-[var(--brand-primary-50)] hover:text-[var(--brand-primary-700)] transition-colors"
            >
              {preset.label}
            </button>
          </li>
        ))}
      </ul>
      <div className="border-t border-[var(--brand-primary-100)] mt-1 px-4 pt-3 pb-2">
        <p className="text-xs text-gray-400 mb-2">Custom range</p>
        <div className="flex items-center gap-2">
          <input
            type="number"
            min="0"
            placeholder="Min"
            value={customMin}
            onChange={(e) => setCustomMin(e.target.value)}
            className="w-full min-w-0 border border-[var(--brand-primary-200)] rounded-md px-2 py-1.5 text-sm outline-none focus:border-[var(--brand-primary-400)]"
          />
          <span className="text-gray-400">–</span>
          <input
            type="number"
            min="0"
            placeholder="Max"
            value={customMax}
            onChange={(e) => setCustomMax(e.target.value)}
            className="w-full min-w-0 border border-[var(--brand-primary-200)] rounded-md px-2 py-1.5 text-sm outline-none focus:border-[var(--brand-primary-400)]"
          />
        </div>
        <button
          type="button"
          disabled={!customMin && !customMax}
          onClick={() => onApply(customMin || 0, customMax || "")}
          className="w-full mt-2 bg-[var(--brand-primary-600)] text-white rounded-md py-1.5 text-sm font-semibold hover:bg-[var(--brand-primary-700)] transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Apply
        </button>
      </div>
    </div>
  );
};

export default PriceRangeDropdown;
